<template lang="pug">
  #Header
    //- ── Topbar ────────────────────────────────────────────────────────────
    div.hd-topbar
      v-container(fluid)
        div.hd-topbar-inner
          div.hd-topbar-left
            v-icon(size='13' color='rgba(255,255,255,0.6)') mdi-map-marker-outline
            span Ferretería mayorista
          div.hd-topbar-right
            template(v-if='!email')
              a.hd-top-link(href='/ingreso')
                v-icon(size='13') mdi-login
                | Ingresar
            template(v-if='email')
              v-menu(offset-y rounded='lg' style='z-index:10000;')
                template(v-slot:activator='{ attrs, on }')
                  div.hd-user-btn(v-bind='attrs' v-on='on')
                    v-icon(size='14') mdi-account-circle
                    span {{email}}
                    v-icon(size='14') mdi-chevron-down
                v-list(dense)
                  v-list-item(v-for='item in items2' :key='item.title' @click='seleccion(item)')
                    v-list-item-icon
                      v-icon(size='16') {{menuIcon(item.title)}}
                    v-list-item-title {{item.title}}

    //- ── Navbar principal ──────────────────────────────────────────────────
    div.hd-navbar
      v-container(fluid)
        div.hd-navbar-inner

          //- Logo
          img(src='@/assets/imgFerco/logo2.png' class='imgLogo' @click='irHome()')

          //- Buscador
          div.hd-search-wrap(v-click-outside='handleClickOutside')
            div.hd-search-box
              v-icon.hd-search-icon mdi-magnify
              input.hd-search-input(
                ref='inpSearch'
                v-model='searchText'
                placeholder='Buscar productos...'
                @focus='handleClickInside()'
                @keyup='handleSearchProduct($event)'
              )
              div.hd-search-loader(v-if='isLoading')
                v-progress-circular(indeterminate size='16' width='2' color='#FF6200')
              v-btn.hd-search-btn(@click='irProductos()').elevation-0
                | Buscar

            //- Dropdown resultados
            div.hd-search-results(v-if='isSearching')
              div.hd-results-list(v-if='searchResults && searchResults.length > 0')
                div.hd-result-item(v-for='(item, i) in searchResults' :key='i' @click='irDetalle(item._id)')
                  div.hd-result-img
                    img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url')
                    img(v-else src='@/assets/imgFerco/image.png')
                  div.hd-result-info
                    span.hd-result-name {{item.art_des}}
                    div.hd-result-meta
                      span.hd-result-sin(v-if='!item.stock || item.stock <= 0') Sin stock
                      span.hd-result-stock(v-if='mostrarS && item.stock > 0') Stock: {{item.stock}}
                      template(v-if='mostrarP && item.precio')
                        span.hd-result-price ${{ item.equivalente > 1 ? (item.precio / item.equivalente).toFixed(2) : item.precio }}
                        span.hd-result-paq(v-if='item.equivalente > 1')  · Paq: ${{item.precio}} ×{{item.equivalente}}
              div.hd-no-results(v-if='policeRes')
                v-icon(color='#c0c8d8') mdi-magnify-close
                span Sin resultados
              div.hd-ver-todos(v-if='!policeRes && searchResults && searchResults.length > 0' @click='irProductos()')
                span Ver todos los resultados
                v-icon(size='14') mdi-arrow-right

          //- Carrito
          div.hd-cart-wrap(style='position:relative;')
            div(@click='mostrarC = !mostrarC' class='cart-trigger')
              div(v-if='totalItemsCarrito > 0' class='cart-badge')
                span {{totalItemsCarrito}}
              v-icon(class='cart-icon') mdi-cart-outline

            div(v-if='mostrarC' class='divDetailCar')
              //- Header
              div(class='car-header')
                div(class='car-header-left')
                  v-icon(color='#1a1a2e' size='20') mdi-cart-outline
                  span Carrito de compra
                  span.car-count(v-if='totalItemsCarrito > 0') {{totalItemsCarrito}}
                v-btn(@click='mostrarC = false' icon small class='car-close').elevation-0
                  v-icon(size='18') mdi-close

              //- Lista de items (carrito principal)
              div(class='car-items')
                div(v-for='item in car' :key='item._id' class='car-item')
                  div(class='car-item-img')
                    img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url' class='car-img')
                    img(v-else-if='item.images && item.images.url' :src='ruta + item.images.url' class='car-img')
                    img(v-else src='@/assets/imgFerco/image.png' class='car-img')
                  div(class='car-item-info')
                    span(class='car-item-name') {{item.art_des || item.nombre}}
                    div(class='car-item-meta')
                      span(class='car-item-qty') x{{item.cant}}
                      span(class='car-item-price') ${{ item.equivalente > 1 ? (item.precio / item.equivalente).toFixed(2) : item.precio }}
                  v-btn(@click='borrar(item)' icon small class='car-item-del').elevation-0
                    v-icon(size='16' color='#c0c8d8') mdi-trash-can-outline

                //- Carritos importados
                div(v-if='carritosExtraStore && carritosExtraStore.length > 0' class='car-extra-section')
                  div(class='car-extra-title')
                    v-icon(small color='#0F4DFF' style='margin-right:4px;') mdi-file-excel
                    span {{carritosExtraStore.length}} carrito(s) importado(s)
                  div(v-for='(cex, ci) in carritosExtraStore' :key='ci' class='car-extra-row')
                    v-icon(small color='#718096') mdi-cart-outline
                    span(style='flex:1;font-size:13px;') Carrito {{ci + 1}}
                    v-chip(x-small color='#0F4DFF' dark style='margin-left:4px;') {{cex.length}} ítems

                //- Vacío total
                div(v-if='totalItemsCarrito === 0' class='car-empty')
                  img(src='@/assets/imgFerco/no hay articulos.png' class='car-empty-img')
                  span ¡No has añadido productos aún!

              //- Footer acciones
              div(class='car-footer')
                v-btn(v-if='totalItemsCarrito > 0' @click='irCarrito()' class='car-btn-primary').elevation-0
                  v-icon(left size='16') mdi-cart-check
                  | Ver carrito
                v-btn(@click='irProduc()' class='car-btn-secondary').elevation-0
                  v-icon(left size='16') mdi-package-variant
                  | Ver productos

</template>
<script>
import { serverImg } from '@/services/environment'
import vClickOutside from 'v-click-outside'
import { EventBus } from '../Events.js'
import Api from '@/services/methods'
import { mapState } from 'vuex'
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data () {
    return {
      sheet: false,
      mostrarC: false,
      selector: 0,
      settings: {},
      car: [],
      count: 0,
      mostrarP: false,
      mostrarS: false,
      isLoading: false,
      isSearching: false,
      policeRes: false,
      searchResults: [],
      searchFacets: null,
      searchText: '',
      email: '',
      ruta: serverImg,
      items2: [],
      badge: 0
    }
  },
  computed: {
    ...mapState(['carritosExtra']),
    carritosExtraStore () {
      return this.$store.state.carritosExtra || []
    },
    totalItemsCarrito () {
      const principal = this.car ? this.car.length : 0
      const extra = this.carritosExtraStore.reduce((sum, c) => sum + c.length, 0)
      return principal + extra
    }
  },
  watch: {
    searchText (val) {
      if (!val) {
        this.cont = 0
        this.isLoading = false
        this.policeRes = false
        this.isSearching = false
        this.searchResults = []
      }
    }
  },
  created () {
    if (this.$route && this.$route.name === 'Productos') {
      if (this.$route.query && this.$route.query.q) {
        this.searchText = this.$route.query.q
      } else if (this.$store.state.searchQuery) {
        this.searchText = this.$store.state.searchQuery
      }
    }
    if (this.$store.state.carFerco !== null) {
      this.car = this.$store.state.carFerco
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb._id) {
      this.items2 = [
        {
          title: 'Perfil'
        },
        {
          title: 'Historial de facturas'
        },
        {
          title: 'Historial de pedidos'
        },
        {
          title: 'Importar pedido'
        },
        {
          title: 'Quiniela'
        },
        {
          title: 'Cerrar Sesión'
        }
      ]
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
      this.email = this.$store.state.fercoWeb.email
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.stock) {
      this.mostrarS = this.$store.state.fercoWeb.stock
    }
  },
  mounted () {
    EventBus.$on('vaciar', data => {
      this.car = this.$store.state.carFerco
    })
    EventBus.$on('limpiarSearch', data => {
      this.cont = 0
      this.isLoading = false
      this.policeRes = false
      this.isSearching = false
      this.searchResults = []
      if (!this.$store.state.searchQuery) {
        this.searchText = ''
      }
    })
    EventBus.$on('actCarrito', data => {
      if (this.$store.state.carFerco !== null) {
        this.car = this.$store.state.carFerco
      }
    })
  },
  methods: {
    irHome () {
      this.$router.push('/')
    },
    irCarrito () {
      this.$router.push('/carrito')
    },
    irDetalle (item) {
      if (this.$route.name === 'Detalle') {
        this.$router.push('/detalle/' + item)
        EventBus.$emit('buscarDetalle', item)
      } else {
        this.$router.push('/detalle/' + item)
      }
    },
    irProduc () {
      this.$router.push({ name: 'Productos' })
    },
    irProductos () {
      if (this.$route.name === 'Productos') {
        this.$router.replace({ name: 'Productos', query: { q: this.searchText } })
        EventBus.$emit('buscarProducto', this.searchText)
      } else {
        this.$router.push({ name: 'Productos', query: { q: this.searchText } })
      }
    },
    async buscarConIA (texto) {
      const cli = (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_precio) ? this.$store.state.fercoWeb.co_precio.trim() : null
      try {
        const res = await Api.post('web/search', { query: texto, codigo: cli })
        if (res.data && res.data.results) {
          this.$store.commit('setSearchFacets', res.data.facets || null)
          this.$store.commit('setSearchQuery', texto)
          this.searchResults = res.data.results
          if (!this.searchResults || this.searchResults.length === 0) this.policeRes = true
        }
      } catch (e) {
        const res2 = await Api.get('productosCom/searchWeb?data=' + texto + '&codigo=' + cli)
        if (res2.data) this.searchResults = res2.data
        if (!this.searchResults || this.searchResults.length === 0) this.policeRes = true
      }
      this.isLoading = false
      this.isSearching = true
    },
    async handleSearchProduct (item) {
      if (item.key === 'Enter') {
        if (this.searchText) {
          this.$refs.inpSearch.blur()
          this.handleClickOutside()
          this.isLoading = true
          await this.buscarConIA(this.searchText)
          this.irProductos()
        }
      } else {
        this.policeRes = false
        this.count++
        const contador = this.count

        if (this.searchText !== '') {
          setTimeout(
            async function (cont) {
              if (cont === this.count) {
                this.isLoading = true
                this.policeRes = false
                await this.buscarConIA(this.searchText)
              }
            }.bind(this),
            800,
            contador
          )
        }
      }
    },
    handleClickInside () {
      if (this.searchText && this.searchResults && this.searchResults.length > 0) {
        this.isSearching = true
      }
    },
    handleClickOutside () {
      this.isSearching = false
      this.policeRes = false
      this.isLoading = false
    },
    seleccion (item) {
      if (item.title === 'Cerrar Sesión') {
        this.$store.dispatch('logout')
        window.location.href = '/'
      }
      if (item.title === 'Ingresar') {
        window.location.href = '/ingreso'
      }
      if (item.title === 'Perfil') {
        window.location.href = '/perfil'
      }
      if (item.title === 'Historial de pedidos') {
        window.location.href = '/historial'
      }
      if (item.title === 'Historial de facturas') {
        window.location.href = '/facturas'
      }
      if (item.title === 'Importar pedido') {
        window.location.href = '/importar-pedido'
      }
      if (item.title === 'Quiniela') {
        window.location.href = '/quiniela'
      }
    },
    revisar () {
      if (this.$store.state.fercoWeb && this.$store.state.fercoWeb._id) {
        this.$router.push('/transaccion')
      } else {
        this.$router.push('/ingreso')
      }
    },
    ir () {
      this.$router.push('/buscar')
    },
    vercarrito () {
      this.$router.push('/carrito')
    },
    logout () {
      this.$store.dispatch('logout')
      window.location.href = '/'
    },
    menuIcon (title) {
      const map = {
        Perfil: 'mdi-account-outline',
        'Historial de facturas': 'mdi-file-document-outline',
        'Historial de pedidos': 'mdi-clipboard-list-outline',
        'Importar pedido': 'mdi-file-excel',
        Quiniela: 'mdi-trophy',
        'Cerrar Sesión': 'mdi-logout'
      }
      return map[title] || 'mdi-circle-small'
    },
    initialize () {
      Api.get('settings').then(res => {
        if (res.data && res.data[0]) {
          this.settings = res.data[0]
        }
      })
    },
    borrar (item) {
      this.$store.dispatch('eliminar', item)
      this.car = this.$store.state.carFerco
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/header.scss";
.divDetailTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid grey;
}
.divCar {
  height: 40px;
  width: 40px;
  background: rgb(15, 77, 255);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  right: 10px;
  top: 5px;
}
.ps-form--quick-search {
  .ps-form__input {
    position: relative;
    width: 100%;
    .v-progress-circular {
      // @include vertical-align();
      right: 10px;
      z-index: 20;
    }
    *::-webkit-input-placeholder {
      /* Google Chrome y Safari */
      color: #ffffff;
      font-style: italic;
    }
    *:-moz-placeholder {
      /* Firefox anterior a 19 */
      color: #ffffff;
      font-style: italic;
    }
    *::-moz-placeholder {
      /* Firefox 19 y superior */
      color: #ffffff;
      font-style: italic;
    }
    *:-ms-input-placeholder {
      /* Internet Explorer 10 y superior */
      color: #ffffff;
      font-style: italic;
    }
  }
}
</style>
